import { trackersFactory } from "./trackersFactory";

const trackers = trackersFactory("header");

const aboutLink = (): void => trackers({ action: "about-link" });

const clinicsLink = (): void => trackers({ action: "clinics-link" });

const crewLink = (): void => trackers({ action: "crew-link" });

const dashboardLink = (): void => trackers({ action: "dashboard-link" });

const homeLink = (): void => trackers({ action: "home-link" });

const chatGuidelinesDoc = (): void =>
  trackers({ action: "chat-guidelines-doc" });

const howItWorksLink = (): void => trackers({ action: "how-it-works-link" });

const gatheringsLink = (): void => trackers({ action: "gatherings-link" });

const libraryLink = (): void => trackers({ action: "library-link" });

const messageConceive = (): void =>
  trackers({ action: "message-conceive-link" });

const messageCrew = (): void => trackers({ action: "message-crew-link" });

const newMemberHomeLink = (): void =>
  trackers({ action: "new-member-home-link" });

const onDemandCoaching = (): void =>
  trackers({ action: "on-demand-coaching-link" });

const philosophyLink = (): void => trackers({ action: "philosophy-link" });

const pricingLink = (): void => trackers({ action: "pricing-link" });

const programLink = (): void => trackers({ action: "program-link" });

const referAFriendLink = (): void =>
  trackers({ action: "refer-a-friend-link" });

const perksLink = (): void => trackers({ action: "perks-link" });

const settingsLink = (): void => trackers({ action: "settings-link" });

const signInLink = (): void => trackers({ action: "log-in-link" });

const signOutLink = (): void => trackers({ action: "log-out-link" });

const signUpLink = (): void => trackers({ action: "sign-up-link" });

const speakWithACoach = (): void =>
  trackers({ action: "speak-with-a-coach-link" });

const speakWithANurse = (): void =>
  trackers({ action: "speak-with-a-nurse-link" });

const upgradeToPremium = (): void =>
  trackers({ action: "upgrade-to-premium-link" });

export const trackHeader = {
  aboutLink,
  chatGuidelinesDoc,
  clinicsLink,
  crewLink,
  dashboardLink,
  homeLink,
  howItWorksLink,
  gatheringsLink,
  libraryLink,
  messageConceive,
  messageCrew,
  newMemberHomeLink,
  onDemandCoaching,
  philosophyLink,
  pricingLink,
  programLink,
  referAFriendLink,
  perksLink,
  settingsLink,
  signInLink,
  signOutLink,
  signUpLink,
  speakWithACoach,
  speakWithANurse,
  upgradeToPremium,
};
